export default "__VITE_ASSET__CUqM1Li2__"